import { render, staticRenderFns } from "./DetallePlanV2.vue?vue&type=template&id=33e4754c&scoped=true"
import script from "./DetallePlanV2.vue?vue&type=script&lang=js"
export * from "./DetallePlanV2.vue?vue&type=script&lang=js"
import style0 from "./DetallePlanV2.vue?vue&type=style&index=0&id=33e4754c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e4754c",
  null
  
)

export default component.exports